import { I18n } from '@calendly/i18n'
import { IconLock } from '@calendly/ui/components/glyphs/IconLock'
import { IconUsers } from '@calendly/ui/components/glyphs/IconUsers'
import { BodyText } from '@calendly/ui/components/typography'
import { UiIcon } from '@calendly/ui/components/ui-icon'

import { isRecapOwnerOrShareable, RECAP_PERMISSION_RELATIONS } from 'features/recaps/constants'
import { useRecapShare } from 'features/recaps/meeting_list/meeting_card/recap_share_context'

import { RecipientPermissionSelect, PermissionSelectReadOnly, getRelationLabel } from './permission_select'
import {
  AccessListItem,
  AccessListItemContent,
  AccessListItemText,
  accessListItemTextLineCss,
  GroupIconContainer,
} from './styles'

export const GroupAccessListItem = ({ userGroup }) => {
  const {
    recapPermission,
    permissionUpdates: {
      getUserGroupRelation,
      setPendingGroupPermission,
    },
  } = useRecapShare()

  const userGroupRelation = getUserGroupRelation(userGroup.uuid, userGroup.relation)

  // A group can only be managed by the sharer/owner if it is not forbidden
  // it means they have access to the group
  const hasAccessToGroupAndCanManage = !userGroup.forbidden && isRecapOwnerOrShareable(recapPermission)

  const renderAction = () => {
    const label = userGroupRelation
      ? getRelationLabel(userGroupRelation)
      : I18n.t('publisher.meeting_recap.share_modal.access_list.permission_select.hidden')

    if (!hasAccessToGroupAndCanManage) {
      return (
        <PermissionSelectReadOnly
          label={label}
          testId="access-list-group-permission"
        />
      )
    }

    return (
      <RecipientPermissionSelect
        uuid={userGroup.uuid}
        value={userGroupRelation ?? RECAP_PERMISSION_RELATIONS.VIEWER}
        onChange={(selectedRelation) => setPendingGroupPermission(userGroup.uuid, selectedRelation)}
        onRemove={() => setPendingGroupPermission(userGroup.uuid, null)}
      />
    )
  }

  return (
    <AccessListItem data-testid={`access-list-group-${userGroup.uuid}`}>
      <AccessListItemContent>
        {userGroup.forbidden ? (
          <>
            <GroupIconContainer>
              <UiIcon icon={IconLock} size="small" title="private group" />
            </GroupIconContainer>
            <AccessListItemText>
              <BodyText className={accessListItemTextLineCss} weight="bold">
                {I18n.t('publisher.meeting_recap.share_modal.access_list.private_group')}
              </BodyText>
              <BodyText className={accessListItemTextLineCss} color="muted" size="small">
                {I18n.t('publisher.meeting_recap.share_modal.access_list.no_group_access')}
              </BodyText>
            </AccessListItemText>
          </>
        ) : (
          <>
            <GroupIconContainer>
              <UiIcon icon={IconUsers} size="small" title="" />
            </GroupIconContainer>
            <AccessListItemText>
              <BodyText className={accessListItemTextLineCss} weight="bold">
                {userGroup.name}
              </BodyText>
              <BodyText className={accessListItemTextLineCss} color="muted" size="small">
                {I18n.t(
                  'publisher.meeting_recap.share_modal.access_list.group_members',
                  { count: userGroup.memberCount },
                )}
              </BodyText>
            </AccessListItemText>
          </>
        )}
      </AccessListItemContent>
      {renderAction()}
    </AccessListItem>
  )
}
